module.exports = __webpack_public_path__ + "static/Pech.ac5071b8.png";